/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment'
import Page from "../../../components/Page";
import adminServices from '../../../services/adminServices';
import LoginServices from '../../../services/loginServices'
import supportServices from '../../../services/supportServices';


const CAT_STYLES = {
    SAT: "bg-purple-50 text-purple-700",
    NEET: "bg-green-50 text-green-700",
    JEE: "bg-blue-50 text-blue-700",
    CLAT: "bg-orange-50 text-orange-700",
};

function CategoryTag({ cat }) {
    return (
        <span className={`text-[11px] font-semibold font-mono px-2 py-0.5 rounded ${"bg-gray-100 text-gray-600"}`}>
            {cat}
        </span>
    );
}
const getTierPriority = (planName = '') => {
    if (!planName) return -1;
    if (planName.startsWith('platform:')) {
        const tier = planName.split(':')[1];
        if (tier === 'PREMIUM') return 6;
        if (tier === 'PRO') return 5;
        if (tier === 'BASIC') return 4;
    }
    if (planName.startsWith('category:')) {
        const tier = planName.split(':')[1];
        if (tier.includes('PREMIUM')) return 3;
        if (tier.includes('PRO')) return 2;
        if (tier.includes('BASIC')) return 1;
    }
    if (planName === 'COURSE') return 0;
    return -1;
};

const getDisplayLabel = (planName = '') => {
    if (!planName) return 'Free';
    if (planName.includes(':')) return planName.split(':')[1];
    return planName;
};

const resolveTopPlan = (planName = '') => {
    if (!planName) return null;
    const plans = planName.split(',').map(p => p.trim());
    plans.sort((a, b) => getTierPriority(b) - getTierPriority(a));
    return plans[0] || null;
};

function SectionLabel({ children }) {
    return (
        <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
            {children}
        </p>
    );
}

function CheckIcon({ done, size = 20 }) {
    return done ? (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" className="shrink-0">
            <circle cx="12" cy="12" r="9" /><path d="M9 12l2 2 4-4" />
        </svg>
    ) : (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="2" className="shrink-0">
            <circle cx="12" cy="12" r="9" />
        </svg>
    );
}

function ChevronRight({ open }) {
    return (
        <svg
            className={`w-4 h-4 text-gray-400 shrink-0 transition-transform duration-200 ${open ? "rotate-90" : ""}`}
            viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
        >
            <path d="M9 18l6-6-6-6" />
        </svg>
    );
}

function AttemptPanel({ panel, onClose }) {
    const { open, name, key, row, isPaid } = panel;



    return (
        <>
            <div
                onClick={onClose}
                className={`absolute inset-0 bg-black/25 backdrop-blur-sm z-40 transition-opacity duration-200 ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
            />
            <div className={`fixed right-0 bottom-0 top-16 w-[480px] bg-white border-l border-gray-200 shadow-2xl z-50 flex flex-col transition-transform duration-300 ease-[cubic-bezier(.4,0,.2,1)] ${open ? "translate-x-0" : "translate-x-full"}`}>
                <div className="flex items-start justify-between px-6 py-5 border-b border-gray-100">
                    <div>
                        <p className="text-base font-bold text-gray-900">Attempt History</p>
                        <p className="text-xs text-gray-400 mt-0.5">{name}</p>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-700 transition-colors p-0.5">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <path d="M18 6L6 18M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto px-6 py-5">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="border-b border-gray-200">
                                {/* {["Attempt", "Date", "Accuracy", "Score", "Time"].map((h) => ( */}
                                {["Attempt", "Date", "Accuracy"].map((h) => (
                                    <th key={h} className="text-[11px] font-bold uppercase tracking-wide text-gray-400 pb-2.5 text-left pr-4">
                                        {h}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {row && row?.attempts_accuracy?.length > 0 && row?.attempts_accuracy?.map((a, i) => (
                                <tr key={i} className="border-b border-gray-100 last:border-0">
                                    <td className="py-3.5 pr-4">
                                        <span className="font-mono text-[13px]">
                                            #{a.attempt_no}{isPaid && a.attempt_no === 1 && ' (free)'}
                                        </span>

                                    </td>
                                    <td className="py-3.5 pr-4 text-[13px] text-gray-600">{a.date_completed ? moment(a.date_completed).format("MMM DD, YYYY") : '-'}</td>
                                    <td className="py-3.5 pr-4 text-[13px] font-semibold text-green-600">{a.accuracy === null ? 0 : a.accuracy} %</td>
                                    {/* <td className="py-3.5 pr-4 font-mono text-[12.5px] text-gray-700">{a.score}</td>
                                    <td className="py-3.5 font-mono text-[12.5px] text-gray-500">{a.time}</td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

// function ModuleRow({ mod }) {
//     return (
//       <div className="bg-white border border-gray-200 rounded-lg p-3">
//         <p className="text-[13px] font-semibold text-gray-700 mb-2">
//           {mod.title}
//         </p>

//         <div className="space-y-2">
//           {mod.lessons.map((lesson) => (
//             <div key={lesson.id}>
//               <div className="flex justify-between text-[12px] text-gray-600 mb-1">
//                 <span>{lesson.title}</span>
//                 <span>{lesson.percent}%</span>
//               </div>

//               <div className="h-2 bg-gray-200 rounded">
//                 <div
//                   className="h-2 bg-green-500 rounded transition-all"
//                   style={{ width: `${lesson.percent}%` }}
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   }
function ModuleRow({ mod }) {

    const isModuleCompleted = mod?.lessons?.length > 0 && mod?.lessons?.every((sm) => sm.percent === 100);
    const modulePercent = mod?.lessons?.length > 0 ? Math.round(mod.lessons.reduce((sum, sm) => sum + sm.percent, 0) / mod.lessons?.length) : 0;
    const [open, setOpen] = useState(false);
    return (
        <div className="border border-gray-200 rounded-lg overflow-hidden mb-2 last:mb-0">
            <div
                onClick={() => setOpen(!open)}
                className="flex items-center justify-between px-3.5 py-3 cursor-pointer hover:bg-gray-50 transition-colors bg-white"
            >
                <div className="flex items-center gap-2.5">
                    <CheckIcon done={isModuleCompleted} />
                    <span className="font-semibold text-[13.5px]">{mod.title}</span>
                </div>
                <div className="flex items-center gap-3">
                    <div className="w-24 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                        <div className="h-full bg-blue-600 rounded-full" style={{ width: `${modulePercent}%` }} />
                    </div>
                    <span className="text-xs text-gray-400 font-mono">{modulePercent} %</span>
                    {modulePercent === 100 && (
                        <span className="text-green-600 font-bold text-xs">Done</span>
                    )}

                    {modulePercent === 0 && (
                        <span className="text-gray-500 font-bold text-xs">Not Started</span>
                    )}

                    {modulePercent > 0 && modulePercent < 100 && (
                        <span className="text-blue-600 font-bold text-xs">In Progress</span>
                    )}
                </div>
            </div>
            {open && (
                <div className="border-t border-gray-100 bg-gray-50">
                    {mod?.lessons?.map((l, i) => (
                        <div key={i} className="flex items-center gap-2.5 px-3.5 py-2">
                            <CheckIcon done={l?.percent === 100} size={16} />
                            <span className={`text-[13px] ${l.done ? "text-gray-600" : "text-gray-500"}`}>{l.title}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

const buildModuleProgress = (plan) => {
    if (!plan?.courses?.length) return [];

    const modules = plan.courses[0].modules || [];

    return modules.map((module) => {
        const subModules = module.subModule || [];

        const lessons = subModules.map((sm) => {
            const topics = sm.subModuleTopics || [];

            const total = topics.length;
            const completed = topics.filter((t) => t.isCompleted).length;

            return {
                id: sm.id,
                title: sm.courseSubmoduleName,
                completed,
                total,
                percent: total ? Math.round((completed / total) * 100) : 0,
            };
        });

        return {
            id: module.id,
            title: module.courseModuleName,
            lessons,
        };
    });
};

const downloadCertificate = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    a.remove();
};

function CoursePlanExpand({ plan }) {


    const moduleData = buildModuleProgress(plan);
    const isFree = plan?.courses?.[0]?.is_free === true;
    const certificateUrl = plan?.courses?.[0]?.certificateUrl || null;
    const overallProgress = plan?.courses?.[0]?.overall_progress || 0;

    return (
        <div className="border-t border-gray-100 bg-gray-50">
            <div className={`grid divide-x divide-gray-200 mx-4 mt-3.5 rounded-lg overflow-hidden border border-gray-200 ${isFree ? "grid-cols-2" : "grid-cols-3"}`}>
                <DetailCell label="Started" value={plan.valid_from ? moment(plan.valid_from).format("MMM DD, YYYY") : '-'} />
                {!isFree && <DetailCell label="Valid To" value={plan.valid_to ? moment(plan.valid_to).format("MMM DD, YYYY") : '-'} />}

                {plan?.courses && plan?.courses?.length > 0 && plan?.courses[0]?.is_free === false &&
                    <DetailCell label="Certificate">
                        {certificateUrl ? (
                            <button
                                onClick={() => downloadCertificate(certificateUrl)}
                                className="flex items-center gap-1.5 text-green-600 font-semibold text-[13px] hover:underline cursor-pointer"
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="8" r="4" />
                                    <path d="M8 16l-2 6 6-3 6 3-2-6" />
                                </svg>
                                Download Certificate
                            </button>
                        ) : (
                            <span className="text-gray-400 text-[13px]">Not available</span>
                        )}
                        {overallProgress > 0 && (
                            <p className="text-[11.5px] text-gray-400 mt-0.5">
                                Progress: {overallProgress}%
                            </p>
                        )}
                    </DetailCell>
                }
            </div>

            <div className="px-4 pb-4 mt-3.5">
                <SectionLabel>Module Progress</SectionLabel>

                <div className="mt-2.5 space-y-4">
                    {moduleData && moduleData.map((mod) => (
                        <ModuleRow key={mod.id} mod={mod} />
                    ))}
                </div>
            </div>
        </div>
    );
}

const buildBundleCourseProgress = (courses = []) => {
    return courses.map((course) => {
        const modules = course.modules || [];
        const totalSubModules = modules.reduce((acc, m) => acc + (m.subModule?.length || 0), 0);
        const completedSubModules = modules.reduce((acc, m) => {
            return acc + (m.subModule?.filter((sm) => {
                const topics = sm.subModuleTopics || [];
                return topics.length > 0 && topics.every((t) => t.isCompleted);
            }).length || 0);
        }, 0);
        const percent = totalSubModules > 0 ? Math.round((completedSubModules / totalSubModules) * 100) : 0;

        const modulesData = modules.map((mod) => {
            const subModules = mod.subModule || [];
            const lessons = subModules.map((sm) => {
                const topics = sm.subModuleTopics || [];
                const total = topics.length;
                const completed = topics.filter((t) => t.isCompleted).length;
                return {
                    id: sm.id,
                    title: sm.courseSubmoduleName,
                    completed,
                    total,
                    percent: total > 0 ? Math.round((completed / total) * 100) : 0,
                };
            });
            return {
                id: mod.id,
                title: mod.courseModuleName,
                lessons,
            };
        });

        return {
            id: course.id,
            title: course.title,
            percent,
            totalSubModules,
            completedSubModules,
            totalModules: modules.length,
            completedModules: modules.filter((m) => {
                const subs = m.subModule || [];
                return subs.length > 0 && subs.every((sm) => {
                    const topics = sm.subModuleTopics || [];
                    return topics.length > 0 && topics.every((t) => t.isCompleted);
                });
            }).length,
            modules: modulesData,
        };
    });
};

function BundleCourseRow({ course }) {
    const [open, setOpen] = useState(false);

    const isCompleted = course.percent === 100;
    const isInProgress = course.percent > 0 && course.percent < 100;

    return (
        <div className="border border-gray-200 rounded-lg mb-2 last:mb-0 overflow-hidden">
            {/* Course header row */}
            <div
                onClick={() => setOpen(!open)}
                className="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors bg-white"
            >
                <div className="flex items-center gap-2.5">
                    <ChevronRight open={open} />
                    <span className="font-semibold text-[13.5px] text-gray-800">{course.title}</span>
                </div>
                <div className="flex items-center gap-3">
                    <div className="w-28 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                        <div
                            className="h-full rounded-full"
                            style={{
                                width: `${course.percent}%`,
                                backgroundColor: course.percent === 100 ? '#16a34a' : '#2563eb',
                            }}
                        />
                    </div>
                    <span className="text-xs text-gray-400 font-mono w-8 text-right">{course.percent}%</span>
                    <span className="text-xs text-gray-400">{course.completedModules}/{course.totalModules} modules</span>
                    {isCompleted && <span className="text-green-600 font-bold text-[12px] min-w-[72px] text-right">Completed</span>}
                    {isInProgress && <span className="text-blue-600 font-bold text-[12px] min-w-[72px] text-right">In Progress</span>}
                    {!isCompleted && !isInProgress && <span className="text-gray-400 font-semibold text-[12px] min-w-[72px] text-right">Not Started</span>}
                </div>
            </div>

            {/* Expanded: module progress */}
            {open && (
                <div className="border-t border-gray-100 bg-gray-50 px-4 pb-4">
                    <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400 pt-3 pb-2">Module Progress</p>
                    <div className="space-y-2">
                        {course.modules.map((mod) => (
                            <ModuleRow key={mod.id} mod={mod} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

function BundlePlanExpand({ plan }) {
    const allcourseDetails = useSelector((state) => state);

    const filteredList = plan?.stripePricingList?.filter(data =>
        allcourseDetails?.currency === 'USD'
            ? data?.related_currency_type_lk === 2
            : data?.related_currency_type_lk === 1
    );

    const courses = buildBundleCourseProgress(plan.courses || []);
    const completedCourses = courses.filter((c) => c.percent === 100).length;

    return (
        <div className="border-t border-gray-100 bg-gray-50">
            {/* Summary detail cells */}
            <div className="grid grid-cols-3 divide-x divide-gray-200 mx-4 mt-3.5 rounded-lg overflow-hidden border border-gray-200">
                <DetailCell label="Valid From" value={moment(plan.valid_from).format("MMM DD, YYYY")} />
                <DetailCell label="Valid To" value={moment(plan.valid_to).format("MMM DD, YYYY")} />
                <DetailCell label="Status" value={plan.status_name} />
            </div>

            {/* Courses list */}
            <div className="px-4 pb-4 mt-3.5">
                <div className="flex items-center gap-2 mb-2.5">
                    <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">Courses</p>
                    <span className="bg-gray-200 text-gray-600 text-[11px] font-semibold rounded-full px-2 py-0.5">
                        {completedCourses}/{courses.length} completed
                    </span>
                </div>
                {courses.map((course) => (
                    <BundleCourseRow key={course.id} course={course} />
                ))}
            </div>
        </div>
    );
}

function BundlePlanRow({ plan }) {

    const allcourseDetails = useSelector((state) => state);
    const [open, setOpen] = useState(false);

    const filteredList = plan?.stripePricingList?.filter(data =>
        allcourseDetails?.currency === 'USD'
            ? data?.related_currency_type_lk === 2
            : data?.related_currency_type_lk === 1
    );
    const isFree = !filteredList || filteredList.length === 0 || !filteredList[0]?.value;

    const courses = plan.courses || [];
    const completedCourses = buildBundleCourseProgress(courses).filter((c) => c.percent === 100).length;

    return (
        <div className="border border-gray-200 rounded-lg mb-2 overflow-hidden">
            <div
                onClick={() => setOpen(!open)}
                className="grid items-center px-4 py-3.5 cursor-pointer hover:bg-gray-50 transition-colors gap-3"
                style={{ gridTemplateColumns: "2fr 1.5fr 2fr 1.5fr" }}
            >
                <div className="flex items-center gap-2">
                    <ChevronRight open={open} />
                    <span className="font-semibold text-[13.5px]">{plan.plan_name}</span>
                </div>
                <span className="font-mono text-[13px] text-gray-500">
                    {!isFree && filteredList?.[0]?.value ? `${filteredList[0].value}/yr` : ''}
                </span>
                <span className="text-[12.5px] text-gray-500">
                    Purchased {moment(plan.valid_from).format("DD MMM YYYY")}
                </span>
                <div className="text-right">
                    {(plan.status_name === "In Active" || plan.canceled_at) && (
                        <span className="text-gray-400 font-semibold text-[12px]">
                            Inactive
                        </span>
                    )}

                    {plan.status_name === "Active" && !plan.canceled_at && (
                        <span className="text-green-600 font-bold text-[12px]">
                            Active
                        </span>
                    )}
                </div>
            </div>

            {open && <BundlePlanExpand plan={plan} />}
        </div>
    );
}

function DetailCell({ label, value, children }) {
    return (
        <div className="bg-white px-4 py-3.5">
            <p className="text-[11.5px] text-gray-400 mb-1">{label}</p>
            {value ? <p className="font-semibold text-sm">{value}</p> : children}
        </div>
    );
}

// function AssessmentPlanExpand({ onViewAttempts, assessments }) {
//     return (
//         <div className="border-t border-gray-100 bg-gray-50">
//             <div className="px-4 py-3 flex items-center gap-2">
//                 <SectionLabel>Attempted</SectionLabel>
//                 <span className="bg-blue-600 text-white text-[11px] font-bold rounded-full px-2 py-0.5">12</span>
//             </div>
//             <div className="overflow-x-auto">
//                 <table className="w-full border-collapse">
//                     <thead>
//                         <tr className="border-b border-gray-200">
//                             {["Assessment", "Category", "Attempts", "Best Accuracy", "Last Attempted", "Action"].map((h) => (
//                                 <th key={h} className="text-[11px] font-bold uppercase tracking-wide text-gray-400 px-4 py-2 text-left whitespace-nowrap">
//                                     {h}
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {assessments && assessments?.length > 0 && assessments?.map((row, i) => (
//                             <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-100 transition-colors">
//                                 <td className="px-4 py-2.5 text-[13px] whitespace-nowrap">{row.title}</td>
//                                 <td className="px-4 py-2.5"><CategoryTag cat={row.type} /></td>
//                                 <td className="px-4 py-2.5 text-[13px] text-gray-600">{row.attempted_count} / 6</td>
//                                 <td className="px-4 py-2.5 text-[13px] text-gray-600">{row.best_accuracy ? row.best_accuracy : 0} %</td>
//                                 <td className="px-4 py-2.5 text-[13px] text-gray-600 whitespace-nowrap">{row.latest_attempt_date ? moment(row.latest_attempt_date).format("MMM DD, YYYY") : '-'}</td>
//                                 <td className="px-4 py-2.5">
//                                     <button
//                                         onClick={() => onViewAttempts(row.title, row.key, row)}
//                                         className="text-blue-600 hover:text-blue-800 text-[12.5px] font-semibold transition-colors hover:underline whitespace-nowrap"
//                                     >
//                                         View Attempts
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>

//         </div>
//     );
// }

function AssessmentPlanExpand({ onViewAttempts, assessments, plan }) {

    const attempted = assessments?.filter(a => a.attempted_count > 0) || [];
    const notStarted = assessments?.filter(a => a.attempted_count === 0) || [];


    const attendedRow = ["Assessment", "Category", "Attempts", "Best Accuracy", "Last Attempted", "Action"]
    const NotattendedRow = ["Assessment", "Category"]
    // attended

    const renderTable = (rows, type) => {
        const headers = type === "attended" ? attendedRow : NotattendedRow;

        return (
            <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="border-b border-gray-200">
                            {headers.map((h) => (
                                <th
                                    key={h}
                                    className="text-[11px] font-bold uppercase tracking-wide text-gray-400 px-4 py-2 text-left whitespace-nowrap"
                                >
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {rows.map((row, i) => (
                            <tr
                                key={i}
                                className="border-b border-gray-100 last:border-0 hover:bg-gray-100 transition-colors"
                            >
                                <td className="px-4 py-2.5 text-[13px] whitespace-nowrap">
                                    {row.title}
                                </td>

                                <td className="px-4 py-2.5">
                                    <CategoryTag cat={row.type} />
                                </td>

                                {type === "attended" && (
                                    <>
                                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                                            {row.attempted_count} / {plan?.is_paid === false ? 5 : 6}
                                        </td>

                                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                                            {row.best_accuracy ? row.best_accuracy : 0} %
                                        </td>

                                        <td className="px-4 py-2.5 text-[13px] text-gray-600 whitespace-nowrap">
                                            {row.latest_attempt_date
                                                ? moment(row.latest_attempt_date).format("MMM DD, YYYY")
                                                : "-"}
                                        </td>

                                        <td className="px-4 py-2.5">
                                            <button
                                                onClick={() => onViewAttempts(row.title, row.key, row, plan?.is_paid)}
                                                className="text-blue-600 hover:text-blue-800 text-[12.5px] font-semibold hover:underline whitespace-nowrap"
                                            >
                                                View Attempts
                                            </button>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="border-t border-gray-100 bg-gray-50">

            {attempted?.length > 0 && (
                <>
                    <div className="px-4 py-3 flex items-center gap-2">
                        <SectionLabel>Attempted</SectionLabel>
                        <span className="bg-blue-600 text-white text-[11px] font-bold rounded-full px-2 py-0.5">
                            {attempted?.length}
                        </span>
                    </div>
                    {renderTable(attempted, "attended")}
                </>
            )}

            {notStarted?.length > 0 && (
                <>
                    <div className="px-4 py-3 flex items-center gap-2 mt-4">
                        <SectionLabel>Not Yet Started</SectionLabel>
                        <span className="bg-gray-400 text-white text-[11px] font-bold rounded-full px-2 py-0.5">
                            {notStarted?.length}
                        </span>
                    </div>
                    {renderTable(notStarted, "Not attended")}
                </>
            )}

        </div>
    );
}

function PlanRow({ plan, onViewAttempts, coming }) {
    const allcourseDetails = useSelector((state) => state);

    const [open, setOpen] = useState(plan.defaultOpen || false);
    const isCancelled = plan.status === "cancelled";
    const filteredList = plan?.stripePricingList?.filter(data =>
        allcourseDetails?.currency === 'USD'
            ? data?.related_currency_type_lk === 2
            : data?.related_currency_type_lk === 1
    );

    console.log(plan, "planplan");


    const isFree = !filteredList || filteredList.length === 0 || !filteredList[0]?.value;

    return (
        <div className={`border border-gray-200 rounded-lg mb-2 overflow-hidden ${isCancelled ? "opacity-60" : ""}`}>
            <div
                onClick={() => setOpen(!open)}
                className="grid items-center px-4 py-3.5 cursor-pointer hover:bg-gray-50 transition-colors gap-3"
                style={{ gridTemplateColumns: "2fr 1.5fr 2fr 1.5fr" }}
            >
                <div className="flex items-center gap-2">
                    <ChevronRight open={open} />
                    <span className={`font-semibold text-[13.5px] ${isCancelled ? "text-gray-400" : ""}`}>{plan.plan_name}</span>
                </div>
                <span className="font-mono text-[13px] text-gray-500">
                    {!isFree && filteredList[0]?.value && `${filteredList[0].value}${coming === "assessment" ? "/mo" : "/yr"}`}
                </span>

                <span className="text-[12.5px] text-gray-500">
                    {!isFree && `${moment(plan.valid_from).format("MMM DD, YYYY")} - ${moment(plan.valid_to).format("MMM DD, YYYY")}`}
                </span>


                <div className="text-right">
                    {!isFree && (
                        moment(plan.valid_to).isBefore(moment(), 'day') ? (
                            <span className="text-gray-500 font-bold text-[12px]">
                                Expired
                            </span>
                        ) : (
                            <>
                                <span className="text-green-600 font-bold text-[12px] block">
                                    Active
                                </span>

                                {plan.status_name === "active-cancels" && (
                                    <span className="text-orange-600 text-[11px] mt-0.5 block">
                                        {plan.cancelNote}
                                    </span>
                                )}
                            </>
                        )
                    )}
                </div>
            </div>

            {open && (coming === "assessment" ? <AssessmentPlanExpand onViewAttempts={onViewAttempts} assessments={plan.assessments} plan={plan} /> : <CoursePlanExpand plan={plan} />
            )}
        </div>
    );
}

const TAB_ICON = {
    overview: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>,
    timeline: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>,
    posthog: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v18h18" /><path d="M7 15l4-6 4 3 4-8" /></svg>,
};

function TabBar({ active, onChange }) {
    const tabs = [
        { key: 'overview', label: 'Overview' },
        { key: 'timeline', label: 'Timeline' },
        { key: 'posthog', label: 'PostHog Activity' },
    ];
    return (
        <div className="flex items-center gap-1 border-b border-gray-200 mb-4">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onChange(tab.key)}
                    className={`flex items-center gap-1.5 px-4 py-2.5 text-[13px] font-semibold border-b-2 -mb-px transition-colors ${active === tab.key
                            ? 'border-blue-600 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'
                        }`}
                >
                    {TAB_ICON[tab.key]}
                    {tab.label}
                </button>
            ))}
        </div>
    );
}

const EVENT_META = {
    registration: {
        color: '#2563EB',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    },
    onboarding: {
        color: '#7C3AED',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" /></svg>,
    },
    subscribed: {
        color: '#0F766E',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></svg>,
    },
    canceled: {
        color: '#DC2626',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>,
    },
    course: {
        color: '#4F46E5',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" /></svg>,
    },
    assessment: {
        color: '#B45309',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M9 11l3 3L22 4" /><path d="M9 4H4v16h16v-5" /></svg>,
    },
    login: {
        color: '#16A34A',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" y1="12" x2="3" y2="12" /></svg>,
    },
    logout: {
        color: '#6B7280',
        icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>,
    },
};

function TimelineRow({ type, title, subtitle, timestamp, last }) {
    const meta = EVENT_META[type] || EVENT_META.subscribed;
    return (
        <div className="flex gap-3">
            <div className="flex flex-col items-center">
                <div
                    className="w-6 h-6 rounded-full shrink-0 flex items-center justify-center"
                    style={{ backgroundColor: meta.color }}
                >
                    {meta.icon}
                </div>
                {!last && <div className="w-px flex-1 bg-gray-200 mt-1" />}
            </div>
            <div className="pb-6 flex-1">
                <p className="text-[13px] font-semibold text-gray-800">{title}</p>
                {subtitle && <p className="text-[12.5px] text-gray-500 mt-0.5">{subtitle}</p>}
                <p className="text-[11.5px] text-gray-400 mt-1">{timestamp ? moment(timestamp).format('MMM DD, YYYY · HH:mm') : '-'}</p>
            </div>
        </div>
    );
}

// Category -> pin styling. The backend emits many event types across a handful of
// categories, so styling keys off category with a per-type override where useful.
const CATEGORY_META = {
    account: { color: '#2563EB', label: 'Account' },
    subscription: { color: '#0F766E', label: 'Subscription' },
    course: { color: '#4F46E5', label: 'Courses' },
    assessment: { color: '#B45309', label: 'Assessments' },
    practice: { color: '#0891B2', label: 'Practice' },
    ai: { color: '#7C3AED', label: 'AI' },
    email: { color: '#DB2777', label: 'Email' },
    profile: { color: '#64748B', label: 'Profile' },
};

function CategoryRow({ event, last }) {
    const meta = CATEGORY_META[event.category] || CATEGORY_META.profile;
    return (
        <div className="flex gap-3">
            <div className="flex flex-col items-center">
                <div className="w-2.5 h-2.5 rounded-full shrink-0 mt-1.5" style={{ backgroundColor: meta.color }} />
                {!last && <div className="w-px flex-1 bg-gray-200 my-1" />}
            </div>
            <div className="pb-5 flex-1 min-w-0">
                <div className="flex items-baseline gap-2 flex-wrap">
                    <p className="text-[13px] font-semibold text-gray-800">{event.title}</p>
                    <span className="text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded"
                        style={{ backgroundColor: `${meta.color}18`, color: meta.color }}>
                        {meta.label}
                    </span>
                </div>
                {event.subtitle && <p className="text-[12.5px] text-gray-500 mt-0.5">{event.subtitle}</p>}
                <p className="text-[11.5px] text-gray-400 mt-1">
                    {event.timestamp ? moment(event.timestamp).format('MMM DD, YYYY · HH:mm') : '-'}
                </p>
            </div>
        </div>
    );
}

// Durations can be seconds long, so minutes alone would round real values to "0 min".
function formatAttemptDuration(seconds) {
    if (!seconds) return null;
    if (seconds < 60) return `${Math.round(seconds)}s`;
    const mins = Math.floor(seconds / 60);
    const rem = Math.round(seconds % 60);
    return rem ? `${mins}m ${rem}s` : `${mins} min`;
}

// Per-assessment attempt table. Attempts are separate assessment_result rows
// (the platform allows up to 5), so every try keeps its own score and timings
// rather than overwriting the previous one.
function AssessmentAttempts({ assessment }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="border border-gray-200 rounded-lg overflow-hidden">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="w-full flex items-center justify-between gap-3 px-3 py-2.5 bg-white hover:bg-gray-50 cursor-pointer border-0 text-left"
            >
                <div className="min-w-0">
                    <p className="text-[13px] font-semibold text-gray-800 truncate">
                        {assessment.assessmentTitle || `Assessment #${assessment.assessmentId}`}
                    </p>
                    <p className="text-[11.5px] text-gray-400 mt-0.5">
                        {assessment.attemptCount === 0
                            ? 'Enrolled — no attempts yet'
                            : `${assessment.attemptCount} attempt${assessment.attemptCount === 1 ? '' : 's'}`}
                        {assessment.bestScore !== null && ` · Best ${assessment.bestScore}`}
                        {assessment.enrolledAt && ` · Enrolled ${moment(assessment.enrolledAt).format('MMM DD, YYYY')}`}
                    </p>
                </div>
                {assessment.attemptCount > 0 && (
                    <span className="text-[11px] text-gray-400 shrink-0">{open ? 'Hide' : 'Show'}</span>
                )}
            </button>
            {open && assessment.attemptCount > 0 && (
                <div className="border-t border-gray-100 overflow-x-auto">
                    <table className="w-full text-[12px]">
                        <thead className="bg-gray-50 text-gray-500">
                            <tr>
                                <th className="text-left font-semibold px-3 py-2">#</th>
                                <th className="text-left font-semibold px-3 py-2">Started</th>
                                <th className="text-left font-semibold px-3 py-2">Completed</th>
                                <th className="text-left font-semibold px-3 py-2">Score</th>
                                <th className="text-left font-semibold px-3 py-2">Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assessment.attempts.map((at) => (
                                <tr key={at.attemptNo} className="border-t border-gray-100">
                                    <td className="px-3 py-2 font-semibold text-gray-700">{at.attemptNo}</td>
                                    <td className="px-3 py-2 text-gray-600">{at.startedAt ? moment(at.startedAt).format('MMM DD, YYYY · HH:mm') : '—'}</td>
                                    {/* When the attempt carries no real timing, date_completed is just a
                                        copy of date_started - showing it would imply an instant finish. */}
                                    <td className="px-3 py-2 text-gray-600">
                                        {at.timingRecorded && at.completedAt
                                            ? moment(at.completedAt).format('MMM DD, YYYY · HH:mm')
                                            : <span className="text-gray-400 italic">Not recorded</span>}
                                    </td>
                                    <td className="px-3 py-2 text-gray-700">
                                        {at.score === null ? '—' : at.score}
                                        {at.percent !== null && <span className="text-gray-400"> ({at.percent}%)</span>}
                                    </td>
                                    <td className="px-3 py-2 text-gray-600">
                                        {at.durationSeconds
                                            ? formatAttemptDuration(at.durationSeconds)
                                            : <span className="text-gray-400 italic">Not recorded</span>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {assessment.attempts.some((at) => !at.timingRecorded) && (
                        <p className="text-[11px] text-gray-400 px-3 py-2 border-t border-gray-100">
                            Some attempts were saved without a start/finish time, so their duration cannot be shown.
                        </p>
                    )}
                </div>
            )}
        </div>
    );
}

function CourseProgressCard({ course }) {
    const pct = Math.min(100, Math.max(0, Number(course.progressPercent) || 0));
    let state = 'Not started';
    let stateStyle = 'bg-gray-50 text-gray-500 border-gray-300';
    if (pct >= 100) {
        state = 'Completed';
        stateStyle = 'bg-green-50 text-green-700 border-green-300';
    } else if (pct > 0) {
        state = 'In progress';
        stateStyle = 'bg-amber-50 text-amber-700 border-amber-300';
    }
    return (
        <div className="border border-gray-200 rounded-lg px-3 py-2.5">
            <div className="flex items-start justify-between gap-2">
                <p className="text-[13px] font-semibold text-gray-800 min-w-0 truncate">
                    {course.courseTitle || `Course #${course.courseId}`}
                </p>
                <span className={`shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded-full border ${stateStyle}`}>
                    {state}
                </span>
            </div>
            <div className="w-full h-1.5 bg-gray-100 rounded-full mt-2 overflow-hidden">
                <div className="h-full bg-blue-600 rounded-full" style={{ width: `${pct}%` }} />
            </div>
            <p className="text-[11.5px] text-gray-400 mt-1.5">
                {pct}% complete
                {course.enrolledAt && ` · Enrolled ${moment(course.enrolledAt).format('MMM DD, YYYY')}`}
                {course.lastActiveAt && ` · Last active ${moment(course.lastActiveAt).format('MMM DD, YYYY')}`}
            </p>
        </div>
    );
}

// Server-built activity timeline. Everything (enrollments, per-attempt assessment
// scores, practice tests, AI sessions, email delivery/clicks, profile changes) comes
// from /dashboard/user-timeline/:userId rather than being re-derived on the client.
function TimelineTab({ userId }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        if (!userId) return undefined;
        let cancelled = false;
        setLoading(true);
        setError(null);
        adminServices.getUserTimeline(userId)
            .then((res) => {
                if (cancelled) return;
                if (res.ok) setData(res.data);
                else setError(res.data?.message || 'Failed to load the activity timeline.');
            })
            .catch(() => { if (!cancelled) setError('Failed to load the activity timeline.'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [userId]);

    if (loading) return <p className="text-gray-400 text-[13px] py-10 text-center">Loading timeline...</p>;
    if (error) {
        return (
            <div className="bg-white border border-gray-200 rounded-xl px-6 py-10 text-center">
                <p className="text-[13px] text-red-600">{error}</p>
            </div>
        );
    }
    if (!data) return null;

    const events = filter === 'all' ? data.events : data.events.filter((e) => e.category === filter);
    const presentCategories = Object.keys(CATEGORY_META).filter((c) => data.events.some((e) => e.category === c));

    return (
        <div className="flex flex-col gap-4">
            {/* Summary */}
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-6 py-5">
                <p className="font-medium mb-3">Activity Summary</p>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
                    {[
                        ['Events', data.summary.totalEvents],
                        ['Subscriptions', data.summary.subscriptions],
                        ['Courses', data.summary.courses],
                        ['Assessments', data.summary.assessments],
                        ['Attempts', data.summary.assessmentAttempts],
                        ['Practice', data.summary.practiceAttempts],
                        ['AI sessions', data.summary.aiSessions],
                    ].map(([label, value]) => (
                        <div key={label} className="border border-gray-100 rounded-lg px-3 py-2 bg-gray-50">
                            <p className="text-[11px] text-gray-400 uppercase tracking-wide">{label}</p>
                            <p className="text-[17px] font-bold text-gray-900">{value}</p>
                        </div>
                    ))}
                </div>
                {!data.emailTrackingAvailable && (
                    <p className="text-[11.5px] text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mt-3">
                        Email tracking tables are not deployed on this environment, so email sends, opens and link
                        clicks are not included below.
                    </p>
                )}
                {data.unavailable?.length > 0 && (
                    <p className="text-[11.5px] text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mt-2">
                        Could not read: {data.unavailable.join(', ')}. Those sections may be incomplete.
                    </p>
                )}
            </div>

            {/* Course progress */}
            {data.courses?.length > 0 && (
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-6 py-5">
                    <p className="font-medium mb-3">Course Progress</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5">
                        {data.courses.map((c) => <CourseProgressCard key={c.courseId} course={c} />)}
                    </div>
                </div>
            )}

            {/* Assessment attempts */}
            {data.assessments?.length > 0 && (
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-6 py-5">
                    <p className="font-medium mb-1">Assessment Attempts</p>
                    <p className="text-[12.5px] text-gray-400 mb-3">
                        Each attempt is stored separately, so every try keeps its own score and timing.
                    </p>
                    <div className="flex flex-col gap-2">
                        {data.assessments.map((a) => <AssessmentAttempts key={a.assessmentId} assessment={a} />)}
                    </div>
                </div>
            )}

            {/* Chronological feed */}
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-6 py-6">
                <p className="font-medium mb-3">Activity Timeline</p>
                <div className="flex items-center gap-1.5 flex-wrap mb-5">
                    {['all', ...presentCategories].map((key) => (
                        <button
                            key={key}
                            type="button"
                            onClick={() => setFilter(key)}
                            className={`px-2.5 py-1 rounded-full text-[11.5px] font-semibold border cursor-pointer transition-colors ${filter === key
                                    ? 'bg-blue-600 text-white border-blue-600'
                                    : 'bg-white text-gray-500 border-gray-200 hover:text-gray-900'
                                }`}
                        >
                            {key === 'all' ? `All (${data.events.length})` : CATEGORY_META[key].label}
                        </button>
                    ))}
                </div>
                {events.length === 0 ? (
                    <div className="w-full border border-gray-200 rounded-xl bg-gray-50 py-10 flex items-center justify-center">
                        <p className="text-gray-400 text-[13px]">No events in this category.</p>
                    </div>
                ) : (
                    <div>
                        {events.map((e, i) => (
                            <CategoryRow key={`${e.category}-${e.type}-${e.timestamp}-${i}`} event={e} last={i === events.length - 1} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}


function formatDuration(seconds) {
    if (seconds == null) return '-';
    const m = Math.floor(seconds / 60);
    const s = Math.round(seconds % 60);
    return `${m}m ${s}s`;
}

// Reuses the existing PostHog-backed support endpoints (getUserSessions / getUserEventFlow)
// that already power the admin Analytics section, scoped to this one user.
function PostHogTab({ userId }) {
    const [sessions, setSessions] = useState([]);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        Promise.all([
            supportServices.getUserSessions(userId),
            supportServices.getUserEventFlow(userId),
        ]).then(([sessionsRes, eventsRes]) => {
            if (cancelled) return;
            if (sessionsRes.ok) setSessions(sessionsRes.data || []);
            if (eventsRes.ok) setEvents(eventsRes.data || []);
            if (!sessionsRes.ok && !eventsRes.ok) {
                setError(
                    sessionsRes.status === 501
                        ? 'PostHog is not configured on the backend yet.'
                        : 'Failed to load PostHog activity for this user.'
                );
            }
        }).catch(() => {
            if (!cancelled) setError('Failed to load PostHog activity for this user.');
        }).finally(() => {
            if (!cancelled) setLoading(false);
        });
        return () => { cancelled = true; };
    }, [userId]);

    if (loading) {
        return <p className="text-gray-400 text-[13px] py-10 text-center">Loading PostHog activity...</p>;
    }
    if (error) {
        return (
            <div className="w-full border border-gray-200 rounded-xl bg-gray-50 py-10 flex items-center justify-center">
                <p className="text-gray-400 text-[13px]">{error}</p>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-4">
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-100">
                    <p className="font-medium">Sessions</p>
                    <p className="text-[12.5px] text-gray-400 mt-0.5">Recorded browser sessions from PostHog.</p>
                </div>
                {sessions.length === 0 ? (
                    <div className="w-full py-10 flex items-center justify-center">
                        <p className="text-gray-400 text-[13px]">No recorded sessions found.</p>
                    </div>
                ) : (
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-50 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wide">
                                <th className="px-6 py-2.5">Date</th>
                                <th className="px-6 py-2.5">Start URL</th>
                                <th className="px-6 py-2.5">Duration</th>
                                <th className="px-6 py-2.5">Clicks</th>
                                <th className="px-6 py-2.5">Errors</th>
                                <th className="px-6 py-2.5">Replay</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sessions.map((s) => (
                                <tr key={s.sessionId} className="border-t border-gray-100 text-[12.5px]">
                                    <td className="px-6 py-3">{moment(s.date).format('MMM DD, YYYY · HH:mm')}</td>
                                    <td className="px-6 py-3 max-w-[220px] truncate">{s.startUrl || '-'}</td>
                                    <td className="px-6 py-3">{formatDuration(s.durationSeconds)}</td>
                                    <td className="px-6 py-3">{s.clicks ?? '-'}</td>
                                    <td className="px-6 py-3">{s.errorCount ?? 0}</td>
                                    <td className="px-6 py-3">
                                        <a href={s.replayUrl} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline font-semibold">
                                            View
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-100">
                    <p className="font-medium">Page & Click Activity</p>
                    <p className="text-[12.5px] text-gray-400 mt-0.5">What this user viewed and clicked, most recent first.</p>
                </div>
                {events.length === 0 ? (
                    <div className="w-full py-10 flex items-center justify-center">
                        <p className="text-gray-400 text-[13px]">No page activity found.</p>
                    </div>
                ) : (
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-50 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wide">
                                <th className="px-6 py-2.5">Time</th>
                                <th className="px-6 py-2.5">Event</th>
                                <th className="px-6 py-2.5">Page / URL</th>
                                <th className="px-6 py-2.5">Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            {events.map((e, i) => (
                                <tr key={`${e.timestamp}-${i}`} className="border-t border-gray-100 text-[12.5px]">
                                    <td className="px-6 py-3">{moment(e.timestamp).format('MMM DD, YYYY · HH:mm')}</td>
                                    <td className="px-6 py-3">{e.event}</td>
                                    <td className="px-6 py-3 max-w-[260px] truncate">{e.url || '-'}</td>
                                    <td className="px-6 py-3 max-w-[200px] truncate">{e.elementText || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default function UserAdminPanel() {
    const navigate = useNavigate();
    const location = useLocation();
    const [panel, setPanel] = useState({ open: false, name: "", key: "", row: "", isPaid: "" });

    const openPanel = (name, key, row, isPaid) => setPanel({ open: true, name, key, row, isPaid });
    const closePanel = () => setPanel((p) => ({ ...p, open: false }));
    const [assessmentPlans, setAssessmentPlans] = useState([])
    const [coursePlans, setCoursePlans] = useState([])
    const [bundleCoursePlans, setBundleCoursePlans] = useState([])
    const [allSubscriptions, setAllSubscriptions] = useState([])
    const [profileDetails, setProfileDetails] = useState(null)
    const [activeTab, setActiveTab] = useState('overview')
    const [recommendedCategories, setRecommendedCategories] = useState([])
    const [onboardingDetails, setOnboardingDetails] = useState(null)


    const [userStatus, setUserStatus] = useState({
        computedStatus: location.state?.computedStatus || location.state?.statusDescription || '',
        suspendedReason: location.state?.suspendedReason || '',
        suspendedBy: location.state?.suspendedBy || '',
        suspendedOn: location.state?.suspendedOn || '',
    });
    
    const [showSuspendModal, setShowSuspendModal] = useState(false);
    const [showRemoveSuspensionModal, setShowRemoveSuspensionModal] = useState(false);
    const [suspendReason, setSuspendReason] = useState('');
    const [removeSuspensionReason, setRemoveSuspensionReason] = useState('');
    const [suspendLoading, setSuspendLoading] = useState(false);
    const [modalError, setModalError] = useState('');
    const [snackbar, setSnackbar] = useState({ open: false, message: '' });

    const isSuspended = userStatus?.computedStatus === 'Suspended' || userStatus?.computedStatus === 'Delete';
    const wasRevoked = !isSuspended && !!userStatus?.revokeReason;

    

    


    const getStatusBadgeClass = (computedStatus) => {
        if (computedStatus === 'Suspended' || computedStatus === 'Delete')
            return "text-[11px] font-bold px-2.5 py-0.5 rounded-full bg-red-100 text-red-800 uppercase tracking-wide";
        if (computedStatus === 'Inactive')
            return "text-[11px] font-bold px-2.5 py-0.5 rounded-full bg-orange-100 text-orange-800 uppercase tracking-wide";
        return "text-[11px] font-bold px-2.5 py-0.5 rounded-full bg-green-100 text-green-800 uppercase tracking-wide";
    };

    const getStatusDisplayLabel = (computedStatus) => {
        if (computedStatus === 'Delete') return 'Account Suspended';
        return computedStatus;
    };

    const MakeInternalUser = async () => {
        try {
            const response = await LoginServices.MakeUserStatus(location.state.id, { status: profileDetails?.user_subtype === 'Internal' ? 'External' : 'Internal' });

            if (!response?.ok) {
                setSnackbar({ open: true, message: 'Failed to update user status. Please try again.', isError: true });
                setTimeout(() => setSnackbar({ open: false, message: '' }), 4000);
                return;
            }

            setSnackbar({ open: true, message: 'User marked as Internal User successfully.', isError: false });
            setTimeout(() => setSnackbar({ open: false, message: '' }), 4000);
            navigate('/app/individual-users');
        } catch (err) {
            setSnackbar({ open: true, message: 'Failed to update user status. Please try again.', isError: true });
            setTimeout(() => setSnackbar({ open: false, message: '' }), 4000);
        }
    };

    const handleSuspendAction = async (action) => {
        const isSuspend = action === 'suspend';
        const reason = isSuspend ? suspendReason : removeSuspensionReason;
        const errorMsg = isSuspend ? 'Please enter a reason before suspending.' : 'Please enter a reason before removing suspension.';

        if (!reason.trim()) { setModalError(errorMsg); return; }

        try {
            setSuspendLoading(true);
            const response = await adminServices.suspendUser(location.state.id, action, reason);

            if (!response.ok) {
                const message = response.data?.message;
                if (isSuspend && message === 'SUSPEND_LIMIT_REACHED') {
                    setShowSuspendModal(false);
                    setSuspendReason('');
                    setModalError('');
                    setSnackbar({ open: true, message: 'This user has reached the maximum suspension limit of 3.', isError: true });
                    setTimeout(() => setSnackbar({ open: false, message: '' }), 4000);
                    getUserDetails();
                } else {
                    setSnackbar({ open: true, message: `Failed to ${isSuspend ? 'suspend user' : 'remove suspension'}. Please try again.`, isError: true });
                    setTimeout(() => setSnackbar({ open: false, message: '' }), 4000);
                }
                return;
            }

            if (isSuspend) { setShowSuspendModal(false); setSuspendReason(''); }
            else { setShowRemoveSuspensionModal(false); setRemoveSuspensionReason(''); }
            setModalError('');
            setSnackbar({
                open: true,
                message: isSuspend ? 'User suspended successfully.' : 'Suspension removed successfully.',
                isError: false,
            });
            setTimeout(() => setSnackbar({ open: false, message: '' }), 4000);
            getUserDetails();
        } catch (err) {
            setSnackbar({ open: true, message: `Failed to ${isSuspend ? 'suspend user' : 'remove suspension'}. Please try again.`, isError: true });
            setTimeout(() => setSnackbar({ open: false, message: '' }), 4000);
        } finally {
            setSuspendLoading(false);
        }
    };

    const handleCloseModal = (type) => {
        if (type === 'suspend') {
            setShowSuspendModal(false);
            setSuspendReason('');
        } else {
            setShowRemoveSuspensionModal(false);
            setRemoveSuspensionReason('');
        }
        setModalError('');
    };

    useEffect(() => {
        getUserDetails()
    }, [])

    const getPlanColor = (planName = '') => {
        if (!planName) return { color: '#6B7280', bg: '#F3F4F6' };
        if (planName.includes('PREMIUM')) return { color: '#B45309', bg: '#FEF3C7' };
        if (planName.includes('PRO')) return { color: '#7C3AED', bg: '#EDE9FE' };
        if (planName.includes('BASIC')) return { color: '#1D4ED8', bg: '#EFF6FF' };
        if (planName === 'COURSE') return { color: '#0F766E', bg: '#F0FDFA' };
        return '#6B7280';
    };

    const PLAN_BADGE_CLASS = "inline-block text-[11px] font-semibold px-2.5 py-1 rounded-full bg-gray-100 whitespace-nowrap w-[120px] text-center overflow-hidden text-ellipsis";
    const getUserDetails = async () => {
        const user = await adminServices.getIndividualDetailsByAdmin(location.state.id);
        const subscriptions = user.data;
        const firstRow = subscriptions?.[0] || {};
        setAllSubscriptions(subscriptions || []);

        adminServices.getUserProfileDetails(location.state.id).then((res) => {
            if (res.ok) setProfileDetails(res.data?.[0] || null);
        });

        adminServices.getRecommendedAssessmentByUserId(location.state.id).then((res) => {
            if (res.ok) {
                const categories = [...new Set((res.data || []).map((row) => row.category_description).filter(Boolean))];
                setRecommendedCategories(categories);
            }
        });

        adminServices.getUserOnboardDetailsByAdmin(location.state.id).then((res) => {
            if (res.ok) setOnboardingDetails(res.data?.result || null);
        });

        setUserStatus({
            computedStatus:  location.state?.computedStatus || '',
            suspendedReason: firstRow?.suspend_reason || '',
            suspendedBy: firstRow?.suspended_by || '',
            suspendedOn: firstRow?.suspended_on || '',
            revokeReason: firstRow?.revoke_reason || '',
            revokedBy: firstRow?.suspended_by || '',
            revokedOn: firstRow?.revoked_on || '',
        });

        const bundleCoursePlans = subscriptions?.filter((sub) => sub.courses !== null && sub.assessments === null && sub.courses?.length > 1);
        const coursePlans = subscriptions?.filter((sub) => sub.courses !== null && sub.courses?.length === 1);
        const assessmentPlans = subscriptions?.filter((sub) => sub.assessments !== null && sub.assessments?.length > 0);

        setBundleCoursePlans(bundleCoursePlans);
        setCoursePlans(coursePlans);
        const plans = assessmentPlans?.filter(
            (sub) => sub.is_paid === false ? true : sub.valid_from !== sub.valid_to
        );
        setAssessmentPlans(plans);
    };

    return (
        <>
            <Page>
                <div className="relative">
                    <div className="bg-gray-100 min-h-screen text-gray-900 text-sm" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                        <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');`}</style>

                        <AttemptPanel panel={panel} onClose={closePanel} />

                        <div
                            onClick={() => {
                                const dashboardReturn = location.state?.__dashboardReturn;
                                if (dashboardReturn) {
                                    navigate('/app/dashboard', { state: { __dashboardReturn: dashboardReturn } });
                                } else {
                                    navigate('/app/individual-users');
                                }
                            }}
                            className="px-7 py-3.5 flex items-center gap-1.5 text-blue-600 text-[13px] font-semibold cursor-pointer hover:underline w-fit"
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6" /></svg>
                            {location.state?.__dashboardReturn ? 'Back to Dashboard' : 'B2C Users'}
                        </div>

                        <div className="px-7 pb-16 flex flex-col gap-4">
                            <div className="bg-white border border-gray-200 rounded-xl shadow-sm flex items-center justify-between px-6 py-5">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold shrink-0">{location.state?.name?.charAt(0)?.toUpperCase()}</div>
                                    <div>
                                        <p className="text-[17px] font-semibold">{location.state.name}</p>
                                        <div className="flex items-center gap-1.5 mt-0.5">
                                            <p className="text-gray-500 text-[13px]">{location.state.email}</p>
                                            {profileDetails && (
                                                <span className="text-[10.5px] font-semibold text-gray-500 bg-gray-100 rounded-full px-2 py-0.5 flex items-center gap-1">
                                                    {profileDetails.google_id ? (
                                                        <>
                                                            <svg width="10" height="10" viewBox="0 0 24 24"><path fill="#4285F4" d="M23.52 12.27c0-.85-.08-1.66-.22-2.45H12v4.63h6.47c-.28 1.5-1.13 2.77-2.4 3.62v3h3.88c2.27-2.09 3.57-5.17 3.57-8.8z" /><path fill="#34A853" d="M12 24c3.24 0 5.95-1.07 7.94-2.92l-3.88-3c-1.08.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.73-4.96H1.26v3.11C3.24 21.3 7.28 24 12 24z" /><path fill="#FBBC05" d="M5.27 14.27A7.2 7.2 0 014.9 12c0-.79.14-1.56.37-2.27V6.62H1.26A11.98 11.98 0 000 12c0 1.93.46 3.76 1.26 5.38l4.01-3.11z" /><path fill="#EA4335" d="M12 4.77c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.94 1.19 15.23 0 12 0 7.28 0 3.24 2.7 1.26 6.62l4.01 3.11C6.22 6.88 8.87 4.77 12 4.77z" /></svg>
                                                            Google
                                                        </>
                                                    ) : (
                                                        <>
                                                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M2 7l10 6 10-6" /></svg>
                                                            Email
                                                        </>
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                        <div className="flex gap-2 mt-1.5 flex-wrap items-center">
                                            {(() => {
                                                const { color, bg } = getPlanColor(resolveTopPlan(location.state?.planName));
                                                return (
                                                    <span
                                                        className="text-[11px] font-semibold rounded-full px-2 py-0.5"
                                                        style={{ color, backgroundColor: bg }}
                                                    >
                                                        {getDisplayLabel(resolveTopPlan(location.state?.planName)) || 'Free'}
                                                    </span>
                                                );
                                            })()}
                                            <span className={getStatusBadgeClass(userStatus?.computedStatus)}>
                                                {getStatusDisplayLabel(userStatus?.computedStatus) || '-'}
                                            </span>
                                        </div>
                                        {activeTab === 'overview' && (() => {
                                            const assessmentCats = onboardingDetails?.assessmentCategories?.map((c) => c.name).filter(Boolean) || [];
                                            const courseCats = onboardingDetails?.courseCategories?.map((c) => c.name).filter(Boolean) || [];
                                            const hasOnboardingCats = assessmentCats.length > 0 || courseCats.length > 0;
                                            const showFallback = !hasOnboardingCats && recommendedCategories.length > 0;
                                            if (!hasOnboardingCats && !showFallback) return null;
                                            return (
                                                <div className="flex gap-x-4 gap-y-1 mt-2 flex-wrap items-center">
                                                    {assessmentCats.length > 0 && (
                                                        <div className="flex items-center gap-1.5 flex-wrap">
                                                            <span className="text-[11px] text-gray-400 font-medium">Assessment interests:</span>
                                                            {assessmentCats.map((cat) => (
                                                                <span key={`a-${cat}`} className="bg-amber-50 text-amber-700 text-[11px] font-semibold rounded-full px-2 py-0.5">
                                                                    {cat}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {courseCats.length > 0 && (
                                                        <div className="flex items-center gap-1.5 flex-wrap">
                                                            <span className="text-[11px] text-gray-400 font-medium">Course interests:</span>
                                                            {courseCats.map((cat) => (
                                                                <span key={`c-${cat}`} className="bg-indigo-50 text-indigo-700 text-[11px] font-semibold rounded-full px-2 py-0.5">
                                                                    {cat}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {showFallback && (
                                                        <div className="flex items-center gap-1.5 flex-wrap">
                                                            <span className="text-[11px] text-gray-400 font-medium">Recommended interests:</span>
                                                            {recommendedCategories.map((cat) => (
                                                                <span key={`r-${cat}`} className="bg-amber-50 text-amber-700 text-[11px] font-semibold rounded-full px-2 py-0.5">
                                                                    {cat}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })()}

                                        {isSuspended && userStatus?.suspendedReason && (
                                            <p className="text-[12px] text-red-500 font-medium mt-1">
                                                Reason: {userStatus.suspendedReason}
                                            </p>
                                        )}

                                        {isSuspended && userStatus?.suspendedOn && (
                                            <p className="text-[12px] text-gray-400 mt-0.5">
                                                Suspended on {moment(userStatus.suspendedOn).format("DD MMM YYYY")} · by {userStatus?.suspendedBy || 'Admin'}
                                            </p>
                                        )}

                                        {wasRevoked && (
                                            <div className="mt-1.5 space-y-0.5">
                                                {userStatus?.revokeReason && (
                                                    <p className="text-[12px] text-blue-600 font-medium">
                                                        Suspension lifted · Reason: {userStatus.revokeReason}
                                                    </p>
                                                )}
                                                {userStatus?.revokedBy && (
                                                    <p className="text-[12px] text-gray-400">
                                                        {userStatus?.revokedOn
                                                            ? `Revoked on ${moment(userStatus.revokedOn).format("DD MMM YYYY")} · by ${userStatus.revokedBy}`
                                                            : `Revoked by ${userStatus.revokedBy}`
                                                        }
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>

                               {location.state?.computedStatus !== 'Deleted' &&
                                <div className="flex items-center gap-3">
                                    {isSuspended ? (
                                        <button
                                            onClick={() => setShowRemoveSuspensionModal(true)}
                                            className="bg-blue-600 hover:bg-blue-700 text-white text-[13px] font-semibold px-5 py-2.5 rounded-lg transition-colors shrink-0"
                                        >
                                            Remove Suspension
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => setShowSuspendModal(true)}
                                            className="bg-red-600 hover:bg-red-700 text-white text-[13px] font-semibold px-5 py-2.5 rounded-lg transition-colors shrink-0"
                                        >
                                            Suspend User
                                        </button>
                                    )}

                                    <button onClick={MakeInternalUser} className="bg-gray-600 hover:bg-gray-700 text-white text-[13px] font-semibold px-5 py-2.5 rounded-lg transition-colors shrink-0">
                                        Make {profileDetails?.user_subtype === 'Internal' ? 'External' : 'Internal'} User

                                    </button>
                                </div>}



                            </div>


                            <TabBar active={activeTab} onChange={setActiveTab} />

                            {activeTab === 'timeline' && (
                                <TimelineTab userId={location.state?.id} />
                            )}

                            {activeTab === 'posthog' && (
                                <PostHogTab userId={location.state.id} />
                            )}

                            {activeTab === 'overview' && (
                                <>
                                    {/* Identity Card */}
                                    <div className="bg-white border border-gray-200 rounded-xl shadow-sm px-6 py-6">
                                        <p className="font-medium">Identity</p>
                                        <div className="grid grid-cols-2 gap-y-5 mt-5">
                                            {[
                                                { label: "Full Name", value: location?.state?.name || "-" },
                                                { label: "Email", value: location?.state?.email || "-" },
                                                {
                                                    label: "Joined",
                                                    value: location?.state?.createDateTime
                                                        ? moment(location.state.createDateTime).format("MMM DD, YYYY")
                                                        : "-",
                                                },
                                                {
                                                    label: "Last Active",
                                                    value: location?.state?.last_login
                                                        ? moment(location.state.last_login).format("MMM DD, YYYY")
                                                        : "-",
                                                },
                                            ].map((f) => (
                                                <div key={f.label}>
                                                    <p className="text-[12px] text-gray-400 mb-1">{f.label}</p>
                                                    <p className="font-medium">{f.value}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                                        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
                                            <p className="font-medium">Subscriptions & Activity</p>

                                            <span className="text-xs text-gray-400">Managed via Stripe</span>
                                        </div>

                                        <div className="flex items-start gap-2.5 mx-6 my-3.5 p-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-500 text-[12.5px] leading-relaxed">
                                            <svg className="shrink-0 mt-0.5 text-gray-400" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                                            </svg>
                                            In production, subscription data is written via Stripe webhook events (customer.subscription.created / updated / deleted). Expand any row to view assessments and attempt history. Demo data is seeded.
                                        </div>

                                        <div className="px-6 pb-2">
                                            <div className="py-3.5 flex items-center gap-2">
                                                <SectionLabel>Assessment Plans</SectionLabel>
                                                <span className="bg-gray-100 text-gray-500 text-[11px] font-semibold rounded-full px-2 py-0.5">{assessmentPlans?.length}</span>
                                            </div>
                                            {assessmentPlans && assessmentPlans?.length > 0 ? assessmentPlans?.map((plan) => (
                                                <PlanRow key={plan.id} plan={plan} onViewAttempts={openPanel} coming="assessment" />
                                            ))
                                                :
                                                <div className="w-full border border-gray-200 rounded-xl bg-white py-10 flex items-center justify-center">
                                                    <p className="text-gray-350 text-[15px]">
                                                        No assessment plan subscriptions.
                                                    </p>
                                                </div>

                                            }
                                        </div>

                                        <div className="px-6 pb-5">
                                            <div className="py-3.5 flex items-center gap-2">
                                                <SectionLabel>Course Plans</SectionLabel>
                                                <span className="bg-gray-100 text-gray-500 text-[11px] font-semibold rounded-full px-2 py-0.5">{coursePlans?.length}</span>
                                            </div>
                                            {coursePlans && coursePlans?.length > 0 ? coursePlans?.map((plan) => (
                                                <PlanRow key={plan.id} plan={plan} onViewAttempts={openPanel} coming="course" />
                                            ))
                                                :
                                                <div className="w-full border border-gray-200 rounded-xl bg-white py-10 flex items-center justify-center">
                                                    <p className="text-gray-350 text-[15px]">
                                                        No course plan subscriptions.
                                                    </p>
                                                </div>
                                            }
                                        </div>

                                        <div className="px-6 pb-5">
                                            <div className="py-3.5 flex items-center gap-2">
                                                <SectionLabel>Bundle Courses</SectionLabel>
                                                <span className="bg-purple-100 text-purple-700 text-[11px] font-semibold rounded-full px-2 py-0.5">
                                                    {bundleCoursePlans?.length} {bundleCoursePlans?.length === 1 ? 'bundle' : 'bundles'}
                                                </span>
                                            </div>
                                            {bundleCoursePlans && bundleCoursePlans?.length > 0 ? bundleCoursePlans?.map((plan) => (
                                                <BundlePlanRow key={plan.id} plan={plan} />
                                            ))
                                                :
                                                <div className="w-full border border-gray-200 rounded-xl bg-white py-10 flex items-center justify-center">
                                                    <p className="text-gray-350 text-[15px]">
                                                        No bundle course subscriptions.
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>
                    </div>
                </div>

                {showSuspendModal && (
                    <div id="modal-suspend" className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-6">
                            <div className="flex items-center justify-between mb-4">
                                <h2 className="text-[16px] font-semibold text-gray-900">Suspend User</h2>
                                <button id="btn-suspend-modal-close" onClick={() => handleCloseModal('suspend')} className="text-gray-400 hover:text-gray-600 transition-colors">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12" /></svg>
                                </button>
                            </div>
                            <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-3 mb-5">
                                <div className="flex items-start gap-2.5">
                                    <svg className="shrink-0 mt-0.5 text-red-400" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
                                    </svg>
                                    <div>
                                        <p className="text-[13px] font-semibold text-red-700">{location.state.name}</p>
                                        <p className="text-[12.5px] text-red-600 mt-0.5">This user will be suspended and will not be able to access the platform.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-5">
                                <label htmlFor="suspend-reason" className="block text-[12.5px] font-medium text-gray-700 mb-1.5">
                                    Internal reason <span className="text-gray-400 font-normal">(not sent to user)</span>
                                    <textarea
                                        id="suspend-reason"
                                        value={suspendReason}
                                        onChange={(e) => { setSuspendReason(e.target.value); if (e.target.value.trim()) setModalError(''); }}
                                        placeholder="e.g. Suspicious activity, policy violation..."
                                        rows={4}
                                        className={`w-full border rounded-lg px-3.5 py-2.5 text-[13px] text-gray-700 placeholder-gray-400 resize-none focus:outline-none focus:ring-2 transition ${modalError ? 'border-red-400 focus:ring-red-200 focus:border-red-400' : 'border-gray-200 focus:ring-red-200 focus:border-red-300'}`}
                                    />
                                </label>
                                {modalError && <p id="suspend-modal-error" className="text-[12px] text-red-500 mt-1.5">{modalError}</p>}
                            </div>
                            <div className="flex gap-3 justify-end">
                                <button id="btn-suspend-cancel" onClick={() => handleCloseModal('suspend')} className="px-5 py-2.5 rounded-lg border border-gray-200 text-[13px] font-semibold text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
                                <button id="btn-suspend-confirm" onClick={() => handleSuspendAction('suspend')} disabled={suspendLoading} className="px-5 py-2.5 rounded-lg bg-red-500 hover:bg-red-600 text-white text-[13px] font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
                                    {suspendLoading ? 'Suspending...' : 'Suspend User'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showRemoveSuspensionModal && (
                    <div id="modal-revoke" className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-6">
                            <div className="flex items-center justify-between mb-4">
                                <h2 className="text-[16px] font-semibold text-gray-900">Remove Suspension</h2>
                                <button id="btn-revoke-modal-close" onClick={() => handleCloseModal('revoke')} className="text-gray-400 hover:text-gray-600 transition-colors">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12" /></svg>
                                </button>
                            </div>
                            <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 mb-5">
                                <div className="flex items-start gap-2.5">
                                    <svg className="shrink-0 mt-0.5 text-blue-500" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
                                    </svg>
                                    <div>
                                        <p className="text-[13px] font-semibold text-blue-700">{location.state.name}</p>
                                        <p className="text-[12.5px] text-blue-600 mt-0.5">Suspension will be lifted immediately. The user will regain access to the platform.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-6">
                                <label htmlFor="remove-suspension-reason" className="block text-[12.5px] font-medium text-gray-700 mb-1.5">
                                    Reason for lifting suspension <span className="text-gray-400 font-normal">(required)</span>
                                    <textarea
                                        id="remove-suspension-reason"
                                        value={removeSuspensionReason}
                                        onChange={(e) => { setRemoveSuspensionReason(e.target.value); if (e.target.value.trim()) setModalError(''); }}
                                        placeholder="e.g. Issue resolved, false positive..."
                                        rows={4}
                                        className={`w-full border rounded-lg px-3.5 py-2.5 text-[13px] text-gray-700 placeholder-gray-400 resize-none focus:outline-none focus:ring-2 transition ${modalError ? 'border-red-400 focus:ring-red-200 focus:border-red-400' : 'border-gray-200 focus:ring-blue-200 focus:border-blue-300'}`}
                                    />
                                </label>
                                {modalError && <p id="revoke-modal-error" className="text-[12px] text-red-500 mt-1.5">{modalError}</p>}
                            </div>
                            <div className="flex gap-3 justify-end">
                                <button id="btn-revoke-cancel" onClick={() => handleCloseModal('revoke')} className="px-5 py-2.5 rounded-lg border border-gray-200 text-[13px] font-semibold text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
                                <button id="btn-revoke-confirm" onClick={() => handleSuspendAction('revoke')} disabled={suspendLoading} className="px-5 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-[13px] font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
                                    {suspendLoading ? 'Removing...' : 'Remove Suspension'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </Page>
            {snackbar.open && (
                <div className="fixed right-6 z-[9999] text-[13px] font-medium px-5 py-3 rounded-lg shadow-xl border"
                    style={{ top: '80px', backgroundColor: snackbar.isError ? '#FEF2F2' : '#F0FDF4', color: snackbar.isError ? '#991B1B' : '#166534', borderColor: snackbar.isError ? '#FECACA' : '#BBF7D0' }}>
                    {snackbar.message}
                    <button onClick={() => setSnackbar({ open: false, message: '' })} className="ml-4 hover:opacity-70">✕</button>
                </div>
            )}
        </>
    );
}
